module.exports = __webpack_public_path__ + "img/sol_cap2.75e27e0e.png";